import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskRequirementSelfScheduleAdded_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskRequirementSelfScheduleAdded_ActivityLogFragment;
}

const ActivityLogTaskRequirementSelfScheduleAdded: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.createdSelfScheduleRequest"
    />
  );
};

ActivityLogTaskRequirementSelfScheduleAdded.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskRequirementSelfScheduleAdded_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskRequirementSelfScheduleAdded;
